<template>
  <div class="teacher-overview">
    <div class="teacher-overview-welcome">
      <Welcome />
      <PersonalData :request="request"
                    :serveUrl="serveUrl"
                    @bookDeatils="bookDetails"
                    @eCardDeatils="eCardDetails"
                    @paperDeatils="paperDetails"
                    @researchDeatils="researchDetails"
                    @mailBoxDeatils="mailBoxDetails" />
    </div>
    <div class="teacher-overview-todo">
      <div class="teacher-overview-todo-item"
           @click="$router.push({ name: 'EventsCenter', params: { tabNum: 0 } })">
        <div class="teacher-overview-todo-item-left">
          <sw-icon icon="todo"></sw-icon>
          <div>
            <div class="teacher-overview-todo-item-title">我的待办</div>
            <div class="teacher-overview-todo-item-value">{{ eventData.todo_count || 0 }}</div>
          </div>
        </div>
        <div class="teacher-overview-todo-item-right">
          <div>
            超时：<span>{{ eventData.todo_timeout || 0 }}</span>
          </div>
          <div>
            催办：<span>{{ eventData.todo_urgent || 0 }}</span>
          </div>
        </div>
      </div>
      <div class="teacher-overview-todo-item"
           @click="$router.push({name: 'EventsCenter', params: { tabNum: 1 } })">
        <div class="teacher-overview-todo-item-left">
          <sw-icon icon="file-send"></sw-icon>
          <div>
            <div class="teacher-overview-todo-item-title">我的流程-进行中</div>
            <div class="teacher-overview-todo-item-value">{{ eventData.apply_ing_count || 0 }}</div>
          </div>
        </div>
        <div class="teacher-overview-todo-item-right">
          <div>
            本周：<span>{{ eventData.handle_week || 0 }}</span>
          </div>
          <div>
            总数：<span>{{ eventData.apply_count || 0 }}</span>
          </div>
        </div>
      </div>
      <div class="teacher-overview-todo-item"
           @click="$router.push({name: 'ScheduleCenter'})">
        <div class="teacher-overview-todo-item-left">
          <sw-icon icon="calendar"></sw-icon>
          <div>
            <div class="teacher-overview-todo-item-title">今日日程</div>
            <div class="teacher-overview-todo-item-value">{{ todaySchedule.todayScheduleCount }}</div>
          </div>
        </div>
        <div class="teacher-overview-todo-item-right">
          <div>
            待开始：<span>{{ todaySchedule.toStartCount }}</span>
          </div>
          <div>
            进行中：<span>{{ todaySchedule.underwayCount }}</span>
          </div>
        </div>
      </div>
      <div class="teacher-overview-todo-item"
           @click="$router.push({ name: 'MessagesCenter' })">
        <div class="teacher-overview-todo-item-left">
          <sw-icon icon="bell"></sw-icon>
          <div>
            <div class="teacher-overview-todo-item-title">未读消息</div>
            <div class="teacher-overview-todo-item-value">{{ messageData.unReadedCount || 0 }}</div>
          </div>
        </div>
        <div class="teacher-overview-todo-item-right">
          <div>
            今日：<span>{{ messageData.unReadedStarCount || 0 }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Welcome from '@/views/Home/components/Welcome';
  import { getEventCount } from '@/api/events';
  import { getTodaySchedule } from '@/api/calendar';
  import { getUnreadedMessageList } from '@/api/message';
  export default {
    name: "TeahcerOverview",
    components: {
      Welcome
    },
    data () {
      return {
        // 事务统计数据
        eventData: {},
        // 消息统计消息
        messageData: {},
        // 今日日程
        todaySchedule: {},
      }
    },
    computed: {
      ...mapGetters([
        'token',
        'userInfo',
        'serveUrl',
        'request',
        'flowServeUrl',
        'messageUrl',
      ]),
    },
    created: function () {
      this.handEventCount();
      this.handMessageRecord(0);
      this.handMessageRecord(1);
      this.handTodaySchedule();
    },
    methods: {
      bookDetails () {
        window.open('http://www.baidu.com');
      },
      eCardDetails () {
        window.open('http://www.baidu.com');
      },
      paperDetails () {
        window.open('http://www.baidu.com');
      },
      researchDetails () {
        window.open('http://www.baidu.com');
      },
      mailBoxDetails () {
        window.open('http://www.baidu.com');
      },
      handEventCount () {
        let data = {
          request: this.request,
          serveUrl: this.flowServeUrl,
          header: 'task',
        };
        getEventCount(data).then(res => {
          this.eventData = res.data[0] || {};
        });
      },
      handMessageRecord (star) {
        let noReadData = {
          request: this.request,
          serveUrl: this.messageUrl,
          header: 'message',
          params: {
            pageSize: 20,
            readed: false,
            star: star,
            readerStatus: 0,
            pageIndex: 0,
          },
        };
        getUnreadedMessageList(noReadData).then(res => {
          if (star) {
            this.messageData.unReadedStarCount = res.data.unReadedCount;
          } else {
            this.messageData.unReadedCount = res.data.unReadedCount;
          }
        });
      },
      handTodaySchedule () {
        let data = {
          request: this.request,
          serveUrl: this.serveUrl,
          header: 'portal',
        };
        getTodaySchedule(data).then(res => {
          this.todaySchedule = res.data;
        });
      },
    },

  }
</script>

<style lang="scss">
  @import "@/styles/variables.scss";
  .teacher-overview {
    box-sizing: content-box;
    * {
      box-sizing: content-box;
    }
  }
  .teacher-overview {
    display: flex;
    flex-direction: column;
    &-welcome {
      display: flex;
      //flex-wrap: wrap;
      flex: 1;
      justify-content: space-between;
      align-items: center;
      .PersonalData {
        width: 580px;
        height: 348px;

        .el-tabs {
          margin: 27px 30px;
        }
      }
    }

    &-todo {
      display: flex;
      //flex-basis: 100%;
      cursor: pointer;
      justify-content: space-around;
      align-items: center;
      // height: 66px;
      padding-top: 30px;
      padding-bottom: 30px;
      background-color: #fff;
      box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
      border-radius: 6px;

      .teacher-overview-todo-item {
        display: flex;
        flex: 1;
        justify-content: space-between;
        align-items: center;
        padding-right: 20px;
        margin-left: 20px;

        .sw-icon {
          padding: 12px;
          margin-right: 10px;
          font-size: 36px;
          color: $color-primary;
          background-color: #f5f5f5;
          border-radius: 100%;
        }

        &-left {
          display: flex;
        }

        &-right {
          font-size: 12px;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);

          > div {
            display: flex;

            > span {
              font-size: 16px;
              font-weight: 400;
              line-height: 18px;
              color: rgba(51, 51, 51, 1);
            }
          }

          > div + div {
            margin-top: 10px;
          }
        }

        &:not(:last-child) {
          border-right: 1px solid rgba(230, 230, 230, 1);
        }
      }

      .teacher-overview-todo-item-title {
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
        color: rgba(102, 102, 102, 1);
      }

      .teacher-overview-todo-item-value {
        margin-top: 10px;
        font-size: 38px;
        font-weight: 400;
        line-height: 40px;
        color: rgba(51, 51, 51, 1);
        cursor: pointer;
      }
    }
  }
</style>
